export const enum EUploadStatus {
    NoFileSelected = 'NoFileSelected',
    Uploading = 'Uploading',
    Verifying = "Verifying",
    Uploaded = 'Uploaded',
    Failed = 'Failed'
}